import { render, staticRenderFns } from "./GeographicalDistributionDelete.vue?vue&type=template&id=f57e3216&"
import script from "./GeographicalDistributionDelete.vue?vue&type=script&lang=js&"
export * from "./GeographicalDistributionDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports